import React from "react";
import Language from "../Utils/Languages";

const SubmitButton = ({ text }) => {
    const className = "font-bold pointer shadow-1 red-card white-text rounded-2 px-10 py-3 my-2 mx-auto";
    return <input type="submit" value={Language[text]} className={className} />;
};

export default SubmitButton;
